import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Avatar from '../Avatar';

const AutocompleteOption = ({ props, option }: any) => {
    return (
        <ListItem {...props} key={option?.id}>
            <ListItemAvatar>
                <Avatar name={option?.name} url={option?.imgUrl} />
            </ListItemAvatar>
            <ListItemText
                primary={option?.name}
                secondary={option?.email}
                primaryTypographyProps={{ variant: 'body1' }}
                secondaryTypographyProps={{ variant: 'body2' }}
            />
        </ListItem>
    );
};

export default AutocompleteOption;
